import '../utilities/css.js';
import '../doubleclick/css.js';
import '../draggable/css.js';
import '../droppable/css.js';
import '../sortable/css.js';
import '../resizable/css.js';
import '../inlineedit/css.js';
import '../contextmenu/css.js';
import '../pager/css.js';
import './datatable.scss';